// =============================================================================
// FILE:
// src/modules/pms/task_material/services/taskMaterialScrapService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";

// =============================================================================
// CREATE MATERIAL SCRAP
// =============================================================================

export const createMaterialScrap = async (

  payload

) => {

  const response = await axiosClient.post(

    "/api/pms/task-material-scrap/create",

    payload
  );

  return response.data;
};